import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { DataService } from '../../../../core/providers/data/data.service';
import { OrderLine, RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables } from '../../../../graphql/generated/generated-types';
import { REMOVE_ITEM_FROM_CART } from '../../product/price-and-actions-block/product-cart.graphql';
import { take } from 'rxjs';

@Component({
  selector: 'app-delete-cart-item-btn-block',
  standalone: true,
  imports: [ButtonModule, ProgressSpinnerModule, CommonModule, RippleModule],
  templateUrl: './delete-cart-item-btn-block.component.html',
  styleUrl: './delete-cart-item-btn-block.component.scss'
})
export class DeleteCartItemBtnBlockComponent {
  @Input() orderLine: OrderLine;
  public loading: boolean = false;


  constructor(private dataService: DataService, ) {}
    


  public removeItem(orderLineItemId: string) {
    this.loading = true;
    this.dataService.mutate<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(REMOVE_ITEM_FROM_CART, {
         id:orderLineItemId,
     }).pipe(
         take(1),
     ).subscribe({
      next: () => {

      },
      error : (error) => {

      },
      complete : () => {
        this.loading = false;
      }
     });
   

   }
  }
  
 

